import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '../../../atoms'

export const MobileFooter: React.FC<{
  onClick: () => void
  disabled: boolean
  isLoading: boolean
}> = ({ onClick, disabled, isLoading }) => {
  return (
    <div className='flex justify-end border-t border-t-border bg-background px-[5vw] py-[10px]'>
      <Button
        onClick={onClick}
        className='px-5 py-[10px]'
        disabled={disabled}
        loading={isLoading}
      >
        <FormattedMessage
          id='ui.BudgetPicker.save'
          defaultMessage='Enregistrer'
        />
      </Button>
    </div>
  )
}
